import React, { useState } from "react";
import {
  LayoutRow,
  LayoutData,
} from "../../../weekly-wins/TableLayoutComponents";
import {
  Badge,
  Button,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { BiTrashAlt, BiMailSend } from "react-icons/bi";
import { MdOutlineMobileFriendly } from "react-icons/md";
import moment from "moment";

const PaginatedUserList = ({
  sharedWithUsers = [],
  isMobile,
  tableCols,
  shareTrivvyViaSMS,
  shareTrivvyViaEmail,
  user,
  profilePicValidityCheck,
  getInitials,
  removeUser,
  viewMember,
  page = 1,
  limit = 10,
  totalUsers = 0,
  listingType,
  usersLoading,
  survey,
  trivvyResults,
  handlePageChange = () => {},
  emailSmsSendModal
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingDeleteUser, setPendingDeleteUser] = useState(null);

  if (usersLoading)
  return null;
  
  if (!sharedWithUsers.length)
  return <div className="text-center">No users found</div>;



  const totalPages = Math.ceil(totalUsers / limit);
  const currentPage = page;
  const startPage = Math.max(2, currentPage - 2);
  const endPage = Math.min(totalPages - 1, currentPage + 2);

  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <li key={i} className={`page-item ${currentPage === i ? "active" : ""}`}>
        <button
          className="page-link rounded-circle mx-1"
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>
      </li>
    );
  }

  const confirmDelete = (user) => {
    if (listingType === "saved") {
      setPendingDeleteUser(user);
      setShowConfirmModal(true);
    } else {
      if (user) removeUser(user.mobileNumber, user.userId);
    }
  };

  const handleConfirmDelete = () => {
    if (pendingDeleteUser) {
      removeUser(pendingDeleteUser.mobileNumber, pendingDeleteUser.userId);
      setPendingDeleteUser(null);
      setShowConfirmModal(false);
    }
  };

  const handleCancelDelete = () => {
    setPendingDeleteUser(null);
    setShowConfirmModal(false);
  };

  const deleteButtonsDisabled = listingType === "saved" && showConfirmModal;

  return (
    <>
      <div style={{
            
    maxHeight:"300px",
    overflowY:"scroll"
      }}>
        {sharedWithUsers.map((item, itemIndex) => {
          if (shareTrivvyViaSMS && !item && item.mobileNumber) return null;
            let dateTrivvySentValue = trivvyResults && trivvyResults.length > 0 ?  trivvyResults.find(e=> e.userId && (e.userId.email == item.email)) : null
            dateTrivvySentValue = dateTrivvySentValue ? dateTrivvySentValue.dateTrivvySent : null;


          const initials =
            item && item.value === user.profile._id
              ? getInitials(user.profile)
              : getInitials(item);

          const avatar = profilePicValidityCheck(item && item.profilePic) ? (
            <div className="list-item__avatar">
              <img src={item.profilePic} />
            </div>
          ) : (
            <span className="list-item__avatar" data-letters={initials}></span>
          );

          const nameDisplay =
            item && item.value === user.profile._id ? (
              "You"
            ) : (
              <span>
                {item.firstName}
                {item.lastName && item.lastName.length > 0
                  ? `, ${item.lastName}`
                  : null}
              </span>
            );

          if (isMobile) {
            return (
              <LayoutData
                fullWidth
                className="col-pl-0 d-block bg-white"
                key={itemIndex}
              >
                <div className="my-2 pl-2 d-flex align-items-center">
                  <div className="grp_member_profile_image cursor-pointer">
                    {avatar}
                  </div>
                  <div className="">
                    <div
                      className="linkedToolView"
                      onClick={() => viewMember(item)}
                    >
                      {nameDisplay}
                    </div>
                  </div>
                  <Button
                    onClick={() => confirmDelete(item)}
                    color="danger"
                    size="sm"
                    className="ml-auto mr-3"
                    disabled={deleteButtonsDisabled}
                  >
                    <BiTrashAlt size={12} />
                  </Button>
                </div>
              </LayoutData>
            );
          }

          return (
            <LayoutRow className="ml-0 mr-0" key={itemIndex}>
              <LayoutData colWidth={tableCols.user} className="bg-white">
                <div className="my-0 pl-2 d-flex align-items-center">
                  <div className="grp_member_profile_image cursor-pointer">
                    {avatar}
                  </div>
                  <div className="">
                    <span>{nameDisplay}</span>
                  </div>
                </div>
              </LayoutData>
              {(shareTrivvyViaSMS) && (
                <LayoutData
                  colWidth={tableCols.phoneNumber}
                  className="bg-white"
                >
                  <span>{(item && item.mobileNumber) || ""}</span>
                </LayoutData>
              )}

              {shareTrivvyViaEmail && (
                <LayoutData colWidth={tableCols.email} className="bg-white">
                  <span>{item && item.email}</span>
                </LayoutData>
              )}


        
        {/* <LayoutData colWidth={tableCols.sharedVia} className="bg-white">
                {item && item.shareMediums && item.shareMediums.length ? (
                  <div className="trivvy-share-via-container">
                    {item.shareMediums.includes("EMAIL") &&
                    shareTrivvyViaEmail ? (
                      <div>
                        <BiMailSend
                          size={"17px"}
                          style={{ marginRight: "3px" }}
                        />
                        <span className="font-13px">
                          {item.emailDate
                            ? moment(item.emailDate).format("MM/DD/YYYY")
                            : ""}
                        </span>
                      </div>
                    ) : (
                      item.shareMediums.includes("SMS") && (
                        <div>
                          {item.smsDate && (
                            <MdOutlineMobileFriendly size={"14px"} />
                          )}
                          <span className="font-13px">
                            {item.smsDate
                              ? moment(item.smsDate).format("MM/DD/YYYY")
                              : ""}
                          </span>
                        </div>
                      )
                    )}
                  </div>
                ) : (
                  ""
                )}
              </LayoutData> */}
        
            


                <LayoutData
                  colWidth={tableCols.dateSent}
                  className="bg-white addedOnDateCss"
                >
                  <span style={{textAlign: 'center'}} >
                {

                  emailSmsSendModal && emailSmsSendModal.type === "EMAIL_LINK" && item.emailDate ? moment(item.emailDate).format("MM/DD/YYYY") :
                  emailSmsSendModal && emailSmsSendModal.type !== "EMAIL_LINK" && item.smsDate ? moment(item.smsDate).format("MM/DD/YYYY") : 
                  dateTrivvySentValue ? moment(dateTrivvySentValue).format("MM/DD/YYYY") :
                ""
                }
                  </span>
               
                </LayoutData>


           {survey.isMessaging!=true?
                <LayoutData
                  colWidth={tableCols.date}
                  className="bg-white addedOnDateCss"
                >
               <span style={{textAlign: 'center'}} >
                     { item.isSubmitted && (
                    item.isSubmittedDate
                      ? moment(item.isSubmittedDate).format("MM/DD/YYYY") :
                    item.lastUpdate
                      ? moment(item.lastUpdate).format("MM/DD/YYYY")
                      : "-"
                ) 
                }
                  </span>
               
                </LayoutData>
                :null}
    

              <LayoutData colWidth={tableCols.action} className="bg-white">
                <div className="d-flex">
                  <Button
                    onClick={() => confirmDelete(item)}
                    color="danger"
                    size="sm"
                    style={{ width: "40px" }}
                    disabled={deleteButtonsDisabled}
                  >
                    <BiTrashAlt size={12} />
                  </Button>
                </div>
              </LayoutData>
            </LayoutRow>
          );
        })}
      </div>

      {/* Pagination */}
      <Row className="mt-1">
        <Col className="d-flex justify-content-between align-items-center flex-column mt-2">
          <small className="text-muted mx-3 d-inline-flex align-items-center">
            Showing &nbsp; <strong>{(page - 1) * limit + 1}</strong>{" "}
            &nbsp;to&nbsp;
            <strong>{Math.min(page * limit, totalUsers)}</strong>&nbsp; of
            &nbsp;
            <strong>{totalUsers}</strong> &nbsp;results
          </small>
          <nav>
            <ul className="pagination justify-content-center">
              <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button
                  className="page-link rounded-circle mx-1"
                  onClick={() => handlePageChange(page - 1)}
                >
                  &lsaquo;
                </button>
              </li>
              <li className={`page-item ${page === 1 ? "active" : ""}`}>
                <button
                  className="page-link rounded-circle mx-1"
                  onClick={() => handlePageChange(1)}
                >
                  1
                </button>
              </li>
              {currentPage > 4 && (
                <li className="page-item disabled">
                  <span className="page-link mx-1">…</span>
                </li>
              )}
              {pages}
              {currentPage < totalPages - 3 && (
                <li className="page-item disabled">
                  <span className="page-link mx-1">…</span>
                </li>
              )}
              {totalPages > 1 && (
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link rounded-circle mx-1"
                    onClick={() => handlePageChange(totalPages)}
                  >
                    {totalPages}
                  </button>
                </li>
              )}
              <li
                className={`page-item ${page === totalPages ? "disabled" : ""}`}
              >
                <button
                  className="page-link rounded-circle mx-1"
                  onClick={() => handlePageChange(page + 1)}
                >
                  &rsaquo;
                </button>
              </li>
            </ul>
          </nav>
        </Col>
      </Row>

      {/* Confirmation Modal */}
      <Modal isOpen={showConfirmModal} toggle={handleCancelDelete}>
        <ModalBody>
          <p className="mb-0">
            Deleting this user means they will not receive the survey questions
            that they have not completed yet. Instead, you can keep them here
            and select the option to not resend the Trivvy to them in a later
            step.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleConfirmDelete}>
            Delete
          </Button>
          <Button color="secondary" onClick={handleCancelDelete}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default PaginatedUserList;
